<template>
  <!-- Rule definition dialog -->
  <v-dialog
    v-model="rule_definition_info_dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="600"
  >
    <v-card v-if="rule_info">
      <v-card-title class="headline justify-space-between">
        <div class="d-flex flex-column">
          <span class="font-weight-bold">{{ ruleName }}</span>
          <div
            v-if="strategyName"
            class="d-flex align-center text-body-2"
            style="gap: 5px"
          >
            <span class="grey--text">{{ $t("Rule_in") }}</span>
            <span :style="{ color: getStrategyColor(rule_info.strategy_id) }">
              {{ strategyName }}
            </span>
          </div>
        </div>
        <v-btn icon @click="rule_definition_info_dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-2">
        <a-pricing-strategy-rule-detail
          v-if="rule"
          :rule="rule"
          :suggestion="rule_info"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import aPricingStrategyRuleDetail from "@/components/pricing-strategy/aPricingStrategyRuleDetail.vue";
import * as Utils from "@/utils.js";
import { mapGetters } from "vuex";

export default {
  name: "a-pricing-strategy-rule-definition-info-dialog",
  components: {
    aPricingStrategyRuleDetail
  },
  computed: {
    rule_definition_info_dialog: {
      get() {
        return this.$store.state.pricingstrategy.rule_definition_info_dialog;
      },
      set(value) {
        this.$store.dispatch(
          "setPricingStrategyRuleDefinitionInfoDialog",
          value
        );
      }
    },
    rule_info: {
      get() {
        return this.$store.state.pricingstrategy.rule_info;
      }
    },
    rule() {
      if (!this.rule_info) return null;
      const storeRule = this.rule_info.rule_id
        ? this.getPricingStrategyRuleById(this.rule_info.rule_id)
        : null;
      // rule_settings trae el snapshot completo de la definición de la regla
      // en el momento de la sugerencia ({action, routes, schedule}): usarlo
      // para el detalle aunque la regla haya cambiado o no esté en el store
      const rs = this.rule_info.rule_settings;
      if (rs && rs.routes) {
        return {
          ...(storeRule || {}),
          routes: rs.routes,
          action: rs.action,
          schedule: rs.schedule
        };
      }
      return storeRule;
    },
    ruleName() {
      return (this.rule && this.rule.name) || "";
    },
    strategyName() {
      if (!this.rule_info) return "";
      return (
        this.rule_info.strategy_name ||
        this.storeStrategyName(this.rule_info.strategy_id)
      );
    },
    ...mapGetters({
      getPricingStrategyStrategyById: "getPricingStrategyStrategyById",
      getPricingStrategyRuleById: "getPricingStrategyRuleById"
    })
  },
  methods: {
    getStrategyColor(strategy_id) {
      const strategy = this.getPricingStrategyStrategyById(strategy_id);
      if (strategy && strategy.color) {
        return Utils.intensifyColor(strategy.color);
      }
      return "grey";
    },
    storeStrategyName(strategy_id) {
      if (!strategy_id) return "";
      const strategy = this.getPricingStrategyStrategyById(strategy_id);
      return strategy && strategy.name ? strategy.name : "";
    }
  }
};
</script>
